module.exports = __webpack_public_path__ + "img/1.b1d4b836.jpg";